import { FaSortAlphaUp as SortUpIcon } from 'react-icons/fa';

export default SortUpIcon;
